import { useState, useEffect } from 'react';
import axios from 'axios';
import '../Donate/Donate.css';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import NumericInput from 'react-numeric-input';

export function AmountSelector({ setSelectedGiftAmount, selectedGiftAmount }) {
  const [error, setError] = useState();
  const [giftAmounts, setGiftAmounts] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [otherAmount, setOtherAmount] = useState("");
  const [isOtherActive, setIsOtherActive] = useState(false);
  const [otherButtonDisplay, setOtherButtonDisplay] = useState("Other");
  const [selectedGiftAmountId, setSelectedGiftAmountId] = useState();

  useEffect(() => {
    const populateGiftAmounts = async () => {
      try {
        await axios.get(`/giftamount`)
          .then((response) => {
            console.log(response);
            if (response.data != null) {
              setGiftAmounts(response.data);
            }
          });

      } catch (e) {
        setError(e.message);
      }
    }

    populateGiftAmounts();
  }, []);

  const selectItem = (e) => {
    e.preventDefault();
    const target = e.currentTarget;
    if (target != null) {    
      const selectedCurrentId = target.attributes['id'];
      const selAmount = target.attributes['data-aria-selectedname'];
      const amountvalue = selAmount.value;
      if (selectedCurrentId.value != null) {
        setSelectedGiftAmountId(selectedCurrentId.value);
        if (selAmount.value === "other") {
          setSelectedGiftAmount("---");
        } else {
          setSelectedGiftAmount(amountvalue);
        }
        setIsActive(true);
        if (selectedCurrentId.value === "0") {
          setIsOtherActive(true);
        }
      }
    }

  }
  const myChange = (e) => {
    const newValue = e.target.value;
    setOtherAmount(newValue);
    setIsOtherActive(false);
    if (!newValue || newValue === "0") {
      setOtherButtonDisplay("Other");
      setSelectedGiftAmount("---");
    }
    else {
      const valueWithCommas = newValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      setOtherButtonDisplay("$" + valueWithCommas);
      setSelectedGiftAmount(valueWithCommas);
    }
  }

  if (error) {
    return (<h2><b>Problem loading gift amounts: {error}</b></h2>);
  } else {
    return (
      <div className="col-sm-4">
        <div className="row">
          <div className="col-sm-12">
            <h2>Amount</h2>
          </div>
        </div>
        {giftAmounts.map((indGiftAmount) => (
          <div className="row" key={`${indGiftAmount.id}`}>
            <div className="col-sm-12">
              <Link to="/" type="button" data-aria-selectedname={indGiftAmount.amount} id={indGiftAmount.id}
                className={`btn blm-btn-primary gift-buttons ${isActive && selectedGiftAmountId === `${indGiftAmount.id}` ? "active" : ""}`}
                onClick={(event) => { selectItem(event) }}>{isActive && selectedGiftAmountId === `${indGiftAmount.id}` ? `$${indGiftAmount.amount}!` : `$${indGiftAmount.amount}`}</Link>
            </div>
          </div>
        ))}
        <div className="row">
          <div className="col-sm-12">
            <Link to="/" type="button" data-aria-selectedname="other" id={0}
              className={`btn blm-btn-primary gift-buttons right ${isActive && selectedGiftAmountId === "0" ? "active" : ""}`}
              onClick={(event) => { selectItem(event) }}>
              {isOtherActive && selectedGiftAmountId === "0" ?
                <div>
                  <span>$</span>
                  <NumericInput
                    className="inlineInputField"
                    value={otherAmount}
                    precision={0}
                    size={5}
                    mobile
                    snap
                    strict
                    onBlur={myChange}
                  />
                  Enter
                </div>
                : `${otherButtonDisplay}`}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

AmountSelector.propTypes = {
  setSelectedGiftAmount: PropTypes.func.isRequired,
  selectedGiftAmount: PropTypes.string.isRequired
}

